/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import SignIn from "layouts/authentication/sign-in";
import Billing from "layouts/billing";
import Dashboard from "layouts/dashboard";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";

// @mui icons
import Icon from "@mui/material/Icon";
import Communities from "layouts/tables/communities";
import Aminities from "layouts/tables/aminities";
import BuildStyles from "layouts/tables/buildstyles";
import Features from "layouts/tables/features";
import Property from "layouts/tables/property";
import Broker from "layouts/tables/broker";
import PropertyBooking from "layouts/tables/property-booking";
import Promotion from "layouts/tables/promotion";
import PropertyInventory from "layouts/tables/property-inventory";
import Enquiry from "layouts/tables/enquiry";
import PrivateRoute from "PrivateRoutes";
import { useDispatch } from "react-redux";

import { setLoginData } from "./redux/Reducers/AuthReducer/authSplice";
import { useEffect } from "react";
function SignOutRoute() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      setLoginData({
        user: {},
        isAuthenticated: false,
      })
    );
    // Optionally, you can clear localStorage/sessionStorage here if needed
  }, [dispatch]);
  return <SignIn />;
}
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <PrivateRoute>
        {" "}
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Community",
    key: "community",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/community",
    component: (
      <PrivateRoute>
        <Communities />
      </PrivateRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Aminities",
  //   key: "aminities",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/aminities",
  //   component: <Aminities />,
  // },
  {
    type: "collapse",
    name: "Build Styles",
    key: "buildstyles",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/buildstyles",
    component: (
      <PrivateRoute>
        <BuildStyles />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Features",
    key: "features",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/features",
    component: (
      <PrivateRoute>
        <Features />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Property",
    key: "property",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/property",
    component: (
      <PrivateRoute>
        <Property />
      </PrivateRoute>
    ),
  },
    {
    type: "collapse",
    name: "Promotion",
    key: "promotion",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/promotion",
    component: (
      <PrivateRoute>
        <Promotion />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Enquiry",
    key: "enquiry",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/enquiry",
    component: (
      <PrivateRoute>
        <Enquiry />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Broker",
    key: "broker",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/broker",
    component: (
      <PrivateRoute>
        <Broker />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Booking",
    key: "booking",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/booking",
    component: (
      <PrivateRoute>
        <PropertyBooking />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Inventory",
    key: "inventory",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/inventory",
    component: (
      <PrivateRoute>
        <PropertyInventory />
      </PrivateRoute>
    ),
  },

  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "collapse",
    name: "Sign Out",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignOutRoute />,
  },
];

export default routes;
